/** قراءة كوكي مقروءة من الجافاسكربت (كوكي الـCSRF بس — توكن الجلسة HttpOnly). */
export function readCookie(name: string): string | null {
  const prefix = `${name}=`;
  for (const part of document.cookie.split(";")) {
    const c = part.trim();
    if (c.startsWith(prefix)) return decodeURIComponent(c.slice(prefix.length));
  }
  return null;
}
